const NoDataMessage = ({ text }) => (
  <div className="d-flex justify-content-center my-0">
    <p
      className="px-3 py-2 fst-italic text-center"
      style={{
        backgroundColor: "#f8f9fa",
        color: "#6c757d",
        borderRadius: "10px",
        border: "1px dashed #ced4da"
      }}
    >
      {text}
    </p>
  </div>
);

export default NoDataMessage;